import { ENTRY_DATA_SECTION_KEYS as SECTION_KEYS } from "@frontend/common";

import { useArticleInfoQuery } from "@api/articleInfo/useArticleInfo";
import { ARTICLE_SECTION_BY_CLASSIFICATION } from "@FillInTableContainer/shared/constants/articleSection.constants";
import { NotCorrectDataFormatError } from "@pages/FillInTablePage/errors/classes/notCorrectDataFormat";
import { useEntryDataValue } from "@stores/entryData";
import { getPressIdFromURL } from "@utils/getStateFromURL";

import { getClinicalTrialEntryDataFormatCheckList } from "../utils/initialEntryDataFormat/initialEntryDataFormatClinicalTrials";
import { getClinicalTrialStatusEntryDataFormatCheckList } from "../utils/initialEntryDataFormat/initialEntryDataFormatClinicalTrialStatus";
import { getCompanyWebsiteVariousPagesEntryDataFormatCheckList } from "../utils/initialEntryDataFormat/initialEntryDataFormatCompanyWebsiteVariousPages";
import { getConferenceScheduleEntryDataFormatCheckList } from "../utils/initialEntryDataFormat/initialEntryDataFormatConferenceSchedule";
import { getCTGEntryDataFormatCheckList } from "../utils/initialEntryDataFormat/initialEntryDataFormatCTG";
import { getDealFilingEntryDataFormatCheckList } from "../utils/initialEntryDataFormat/initialEntryDataFormatDealFiling";
import { getDealEntryDataFormatCheckList } from "../utils/initialEntryDataFormat/initialEntryDataFormatDeals";
import { getExpeditedProgramEntryDataFormatCheckList } from "../utils/initialEntryDataFormat/initialEntryDataFormatExpeditedProgram";
import { getFundingFilingEntryDataFormatCheckList } from "../utils/initialEntryDataFormat/initialEntryDataFormatFundingFiling";
import { getPublicationEntryDataFormatCheckList } from "../utils/initialEntryDataFormat/initialEntryDataFormatPublication";
import { getPublicationJournalEntryDataFormatCheckList } from "../utils/initialEntryDataFormat/initialEntryDataFormatPublicationJournal";
import { getRegulatoryEntryDataFormatCheckList } from "../utils/initialEntryDataFormat/initialEntryDataFormatRegulatory";
import { getVentureCapitalEntryDataFormatCheckList } from "../utils/initialEntryDataFormat/initialEntryDataFormatVentureCapital";

export const useCheckInitialEntryDataFormat = () => {
  const entryData = useEntryDataValue(getPressIdFromURL());
  const { data: articleInfo } = useArticleInfoQuery();

  const articleSection =
    (articleInfo &&
      ARTICLE_SECTION_BY_CLASSIFICATION[articleInfo?.classificationManual]) ||
    "none";

  const checkClassificationEntryDataFormat = () => {
    if (articleSection === "none") return ["Article section not found."];

    if (articleSection === SECTION_KEYS.deals)
      return getDealEntryDataFormatCheckList(entryData);

    if (articleSection === SECTION_KEYS.dealFiling)
      return getDealFilingEntryDataFormatCheckList(entryData);

    if (articleSection === SECTION_KEYS.fundingFiling)
      return getFundingFilingEntryDataFormatCheckList(entryData);

    if (articleSection === SECTION_KEYS.clinicalTrial)
      return getClinicalTrialEntryDataFormatCheckList(entryData);

    if (articleSection === SECTION_KEYS.clinicalTrialStatus)
      return getClinicalTrialStatusEntryDataFormatCheckList(entryData);

    if (articleSection === SECTION_KEYS.companyWebsiteVariousPages)
      return getCompanyWebsiteVariousPagesEntryDataFormatCheckList(entryData);

    if (articleSection === SECTION_KEYS.regulatory)
      return getRegulatoryEntryDataFormatCheckList(entryData);

    if (articleSection === SECTION_KEYS.expeditedProgram)
      return getExpeditedProgramEntryDataFormatCheckList(entryData);

    if (articleSection === SECTION_KEYS.ventureCapital)
      return getVentureCapitalEntryDataFormatCheckList(entryData);

    if (articleSection === SECTION_KEYS.publication)
      return getPublicationEntryDataFormatCheckList(entryData);

    if (articleSection === SECTION_KEYS.publicationJournal)
      return getPublicationJournalEntryDataFormatCheckList(entryData);

    if (articleSection === SECTION_KEYS.conferenceSchedule)
      return getConferenceScheduleEntryDataFormatCheckList(entryData);

    if (articleSection === SECTION_KEYS.ctg)
      return getCTGEntryDataFormatCheckList(entryData);

    return [];
  };

  const checkData = checkClassificationEntryDataFormat();

  const checkDataLength = checkData.length;
  if (checkDataLength > 0) {
    throw new NotCorrectDataFormatError(checkData);
  }
};
